module.exports = __webpack_public_path__ + "img/call_missed.75e150e1.svg";